export default __webpack_public_path__ + "static/media/picture_about_02.6261901d.png";